import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';

import './styles.scss'
import * as bootstrap from 'bootstrap'
import 'boxicons'
import {createPinia} from "pinia";

createApp(App).use(router).use(createPinia()).use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            darkModeSelector: 'light-mode',
        }
    }
}).mount('#app')
